import { reportApi } from '../http/httpClient'

export interface ReportCustomers {
  name: string
  email: string
  cpf: string
  phone: string
  createdAt: string
  available: {
    amount: number
    isAutorized: boolean
    isArchived: boolean
    updatedAt: string
  }
  total: number
  transactions: number
  lastTransaction?: string
}

export interface ReportCustomersResponse {
  customers: ReportCustomers[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
  }
}

export interface ReportCustomersParams {
  search?: string
  startDate?: string
  endDate?: string
  transactionStartDate?: string
  transactionEndDate?: string
  status?: string
  customerStatus?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function reportCustomers(
  params?: ReportCustomersParams | undefined,
) {
  const { data } = await reportApi.get<ReportCustomersResponse>(
    '/report/customers',
    {
      params: {
        ...params,
        customerStatus: params?.customerStatus || undefined,
      },
    },
  )

  return data
}
